@if(inventory.length) {
  <div class="inventory-wrapper">
    <div class="inventory-header row no-gutters">
      <div class="chevron-col"></div>
      <div class="label-col">
        <span>{{viewCurrencyLabel}}</span>
      </div>
      @for(column of columnNames | keyvalue: asIsKeyOrder; track $index) {          
        <div class="dynamic-col">
          <div class="text-align--right white-space--pre-line">
            {{column.value}}
          </div>
        </div>
      }
    </div>
  
    @for(elem of inventory; track $index; let firstElement = $first ) {
      <div [attr.e2e-id]="firstElement ? 'first-inventory-row' : ''" class="">
        @if(getLevelVisibility(elem.level)) {
          <div class="inventory-row row {{getFilterClass(elem.filter_key)}}"
          [ngClass]="{'last-row': isLastLevel(elem.level)}"
          [@verticalExpansion]
          >
            <div class="chevron-col">
              @if(!isLastLevel(elem.level)) {
                <span class="chevron expand-arrow strong " [ngClass]="{rotate: isLastVisibleOrHidden(elem.level)}"
                  (click)="toggleVisibilityForLevelsBelow(elem.level)">
                </span>
              }
            </div>
            <div class="col label-col">
              <span class="d-inline-block" [ngStyle]="{'margin-left.px': getIndentation(elem.level)}">
                {{getFilterValueName(elem.filter_key, elem.filter_value_key)}}
              </span>
              
              @if(firstElement) {
                <span class="left-margin text--normal left-margin">
                  ({{convertPeriodToDateString(elem.filter_value_key, true)}})
                </span>
              }
              @if(elem.filter_key==='week') {
                <span class="left-margin thin">
                  ({{convertPeriodToDateString(elem.filter_value_key)}})
                </span>
              }
            </div>
            @for(attr of columnNames | keyvalue: asIsKeyOrder; track $index;) {
              <div class="dynamic-col text-end">
                  @if(showTooltipCheck({row: elem, column: attr.key})) {
                    <span class="icon-warning text--cta tooltip-container" data-toggle="tooltip" title="Maxuttaget är större än Tillgängligt"></span>
                  }
                  @if(elem[attr.key] !== null) {
                    <span [ngClass]="{'text--danger': elem[attr.key] < 0}" attr.e2e-id="inventory-column-{{attr.key}}" >{{elem[attr.key] | number}}</span>
                  }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}